var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"c-chip",style:({
        color: _setup.props.textColor,
        minHeight: _setup.props.size,
        padding: '0 ' + _setup.props.size,
        fontSize: _setup.props.fontSize
    }),attrs:{"color":_setup.props.backgroundColor,"label":""}},[(_setup.props.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_setup.props.icon)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }